import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
// import L_SASS from "../../assets/img/skills/sass-1.svg";
import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_REDUX_TOOLKIT from "../../assets/img/skills/redux-toolkit.svg";
import L_STYLED_COMPONENTS from "../../assets/img/skills/styled-components.svg";
import L_MATERIAL_UI from "../../assets/img/skills/material-ui-1.svg";
import L_CHAKRA_UI from "../../assets/img/skills/chakra-ui-icon.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import L_REDIS from "../../assets/img/skills/redis.svg";
import L_NEXT_JS from "../../assets/img/skills/next-js.svg";
import L_SOCKET_IO from "../../assets/img/skills/socket-io-svgrepo-com.svg";
import L_FIREBASE from "../../assets/img/skills/firebase.svg";
import L_CLOUDINARY from "../../assets/img/skills/cloudinary.png";
import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_HEROKU from "../../assets/img/skills/heroku.svg";
import L_GITHUB from "../../assets/img/skills/github.svg";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import L_TYPESCRIPT from "../../assets/img/skills/typescript.svg";
import L_C from "../../assets/img/skills/c.png";
import L_CPP from "../../assets/img/skills/cpp.png";
import L_TAILWIND from "../../assets/img/skills/tailwindcss.svg";
import L_BULLMQ from "../../assets/img/skills/bullmq.svg";
import L_SQL from "../../assets/img/skills/sql.svg";
import L_WEBSOCKETS from "../../assets/img/skills/websockets.svg";
import L_STRIPE from "../../assets/img/skills/stripe.svg";
import L_DOCKER from "../../assets/img/skills/docker.svg";
import L_MONGOOSE from "../../assets/img/skills/mongoose.svg";
import L_REST_API from "../../assets/img/skills/rest-api.svg";
import L_MICROSERVICES from "../../assets/img/skills/microservices.svg";
import L_TUYA from "../../assets/img/skills/tuya.svg";
import L_WEBHOOKS from "../../assets/img/skills/webhooks.svg";
import L_EVENT_DRIVEN from "../../assets/img/skills/event-driven.svg";
import L_CICD from "../../assets/img/skills/cicd.svg";
import L_GITLAB from "../../assets/img/skills/gitlab.svg";
import L_POSTMAN from "../../assets/img/skills/postman.svg";
import L_AGILE_SCRUM from "../../assets/img/skills/agile-scrum.svg";
import L_SYSTEM_DESIGN from "../../assets/img/skills/system-design.svg";
import L_NETLIFY from "../../assets/img/skills/Netlify.jpg";
import L_AWS from "../../assets/img/skills/Amazon_Web_Services_Logo.svg.png";

export const skills = {
  frontend: [
    {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML5",
    },
    {
      link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS3",
    },

    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    {
      link: "https://tailwindcss.com/",
      imgAltText: "Tailwind CSS",
      imgSrc: L_TAILWIND,
      skillName: "Tailwind CSS",
    },
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
    },
    {
      link: "https://nextjs.org/",
      imgAltText: "Next.js",
      imgSrc: L_NEXT_JS,
      skillName: "Next.js",
    },
    {
      link: "https://redux.js.org/",
      imgAltText: "Redux",
      imgSrc: L_REDUX,
      skillName: "Redux",
    },
    {
      link: "https://redux-toolkit.js.org/",
      imgAltText: "Redux Toolkit",
      imgSrc: L_REDUX_TOOLKIT,
      skillName: "Redux Toolkit",
    },
    {
      link: "https://mui.com/",
      imgAltText: "Material UI",
      imgSrc: L_MATERIAL_UI,
      skillName: "Material UI",
    },
    {
      link: "https://chakra-ui.com/",
      imgAltText: "Chakra UI",
      imgSrc: L_CHAKRA_UI,
      skillName: "Chakra UI",
    },
    {
      link: "https://styled-components.com/",
      imgAltText: "styled-components",
      imgSrc: L_STYLED_COMPONENTS,
      skillName: "styled-components",
    },
  ],

  backend: [
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node.js",
      imgSrc: L_NODE_JS,
      skillName: "Node.js",
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: L_EXPRESS,
      skillName: "Express",
    },

    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: L_MONGODB,
      skillName: "MongoDB",
    },
    {
      link: "https://mongoosejs.com/",
      imgAltText: "Mongoose",
      imgSrc: L_MONGOOSE,
      skillName: "Mongoose",
    },
    {
      link: "https://redis.io/",
      imgAltText: "Redis",
      imgSrc: L_REDIS,
      skillName: "Redis",
    },
    {
      link: "https://docs.bullmq.io/",
      imgAltText: "BullMQ",
      imgSrc: L_BULLMQ,
      skillName: "BullMQ",
    },
    {
      link: "https://en.wikipedia.org/wiki/SQL",
      imgAltText: "SQL",
      imgSrc: L_SQL,
      skillName: "SQL",
    },
    {
      link: "https://restfulapi.net/",
      imgAltText: "REST API Design",
      imgSrc: L_REST_API,
      skillName: "REST API Design",
    },
    {
      link: "https://microservices.io/",
      imgAltText: "Microservices",
      imgSrc: L_MICROSERVICES,
      skillName: "Microservices",
    },
  ],


  hostingPlatforms: [
    {
      link: "https://aws.amazon.com/console/",
      imgAltText: "AWS",
      imgSrc: L_AWS,
      skillName: "AWS",
    },
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: L_HEROKU,
      skillName: "Heroku",
    },

    {
      link: "https://github.com/",
      imgAltText: "GitHub",
      imgSrc: L_GITHUB,
      skillName: "GitHub",
    },
  ],

  realTime: [
    {
      link: "https://socket.io/",
      imgAltText: "Socket.IO",
      imgSrc: L_SOCKET_IO,
      skillName: "Socket.IO",
    },
    {
      link: "https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API",
      imgAltText: "WebSockets",
      imgSrc: L_WEBSOCKETS,
      skillName: "WebSockets",
    },
    {
      link: "https://firebase.google.com/",
      imgAltText: "Firebase",
      imgSrc: L_FIREBASE,
      skillName: "Firebase",
    },
    {
      link: "https://cloudinary.com/",
      imgAltText: "Cloudinary",
      imgSrc: L_CLOUDINARY,
      skillName: "Cloudinary",
    },
    {
      link: "https://stripe.com/",
      imgAltText: "Stripe",
      imgSrc: L_STRIPE,
      skillName: "Stripe",
    },
    {
      link: "https://developer.tuya.com/",
      imgAltText: "Tuya APIs",
      imgSrc: L_TUYA,
      skillName: "Tuya APIs",
    },
    {
      link: "https://en.wikipedia.org/wiki/Webhook",
      imgAltText: "Webhooks",
      imgSrc: L_WEBHOOKS,
      skillName: "Webhooks",
    },
    {
      link: "https://en.wikipedia.org/wiki/Event-driven_programming",
      imgAltText: "Event-driven Architecture",
      imgSrc: L_EVENT_DRIVEN,
      skillName: "Event-driven Architecture",
    },
  ],



  programmingLanguages: [
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://www.typescriptlang.org/",
      imgAltText: "TypeScript",
      imgSrc: L_TYPESCRIPT,
      skillName: "TypeScript",
    },
    {
      link: "https://www.cprogramming.com/",
      imgAltText: "C",
      imgSrc: L_C,
      skillName: "C",
    },
    {
      link: "https://www.cplusplus.com/",
      imgAltText: "C++",
      imgSrc: L_CPP,
      skillName: "C++",
    },

  ],

  devOps: [
    {
      link: "https://www.docker.com/",
      imgAltText: "Docker",
      imgSrc: L_DOCKER,
      skillName: "Docker",
    },
    {
      link: "https://git-scm.com/",
      imgAltText: "Git",
      imgSrc: L_GIT,
      skillName: "Git",
    },
    {
      link: "https://en.wikipedia.org/wiki/Continuous_integration",
      imgAltText: "CI/CD",
      imgSrc: L_CICD,
      skillName: "CI/CD",
    },
    {
      link: "https://about.gitlab.com/",
      imgAltText: "GitLab",
      imgSrc: L_GITLAB,
      skillName: "GitLab",
    },
    {
      link: "https://www.postman.com/",
      imgAltText: "Postman",
      imgSrc: L_POSTMAN,
      skillName: "Postman",
    },
    {
      link: "https://www.scrum.org/resources/what-is-scrum",
      imgAltText: "Agile/Scrum",
      imgSrc: L_AGILE_SCRUM,
      skillName: "Agile/Scrum",
    },
    {
      link: "https://en.wikipedia.org/wiki/Systems_design",
      imgAltText: "System Design",
      imgSrc: L_SYSTEM_DESIGN,
      skillName: "System Design",
    },
  ],

  development: [
    {
      link: "https://www.netlify.com/",
      imgAltText: "Netlify",
      imgSrc: L_NETLIFY,
      skillName: "Netlify",
    }
  ],

};
